
(function(){
  function syncCartBeforeCheckout(e){
    var form = e.target;
    if(form && (form.action || '').includes('/checkout')){
      e.preventDefault();
      fetch('/cart.js', {credentials:'same-origin'})
      .then(function(){ form.submit(); })
      .catch(function(){ form.submit(); });
    }
  }
  document.addEventListener('submit', syncCartBeforeCheckout, true);
})();
